import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../auth.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { Messages } from "../../model/messages";
import { BehaviorSubject } from "rxjs";
import { ActionButtonSubmit } from "../../model/action-button-submit";
import { BreakpointObserver } from "@angular/cdk/layout";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  invalidLogin = false;
  isLoading = false;
  messages = new BehaviorSubject<Messages>(Messages.EMPTY);

  buttonLabel: string = "login.submit";
  screenSize: "desktop" | "tablet" | "mobile";

  constructor(
    private loginService: AuthService,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    private router: Router,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ["", [Validators.required, Validators.minLength(4)]],
      password: ["", [Validators.required, Validators.minLength(4)]],
    });

    this.breakpointObserver
      .observe([
        "(max-width: 599px)",
        "(min-width: 600px) and (max-width: 959px)",
        "(min-width: 960px)",
      ])
      .subscribe((result) => {
        if (result.matches) {
          if (this.breakpointObserver.isMatched("(max-width: 599px)")) {
            this.screenSize = "mobile";
          } else if (
            this.breakpointObserver.isMatched(
              "(min-width: 600px) and (max-width: 959px)"
            )
          ) {
            this.screenSize = "tablet";
          } else if (this.breakpointObserver.isMatched("(min-width: 960px)")) {
            this.screenSize = "desktop";
          }

          this.adjustLoginForm();
        }
      });
  }

  adjustLoginForm() {
    if (this.screenSize === "mobile") {
      this.loginForm.controls["username"].setValidators([
        Validators.required,
        Validators.minLength(3),
      ]);
    } else {
      this.loginForm.controls["username"].setValidators([
        Validators.required,
        Validators.minLength(4),
      ]);
    }
    this.loginForm.controls["username"].updateValueAndValidity();
  }

  onSignIn(action?: ActionButtonSubmit) {
    this.isLoading = true;
    if (this.loginForm.invalid) {
      this.isLoading = false;
      this.invalidLogin = true;
      Object.keys(this.loginForm.controls).forEach((field) => {
        const control = this.loginForm.get(field);
        if (control) {
          control.markAsTouched({ onlySelf: true });
        }
      });
      action?.result(false);
      return;
    }

    this.messages.next(Messages.EMPTY);

    const username = this.loginForm.controls["username"].value;
    const password = this.loginForm.controls["password"].value;
    this.loginService
      .login(username, password)
      .subscribe((responseMessages) => {
        action?.messages(responseMessages);
        this.isLoading = false;
        if (responseMessages.hasAnyMessages) {
          this.invalidLogin = true;
          this.messages.next(responseMessages);
        } else {
          this.invalidLogin = false;
          this.router.navigate([""]);
        }
      });
  }
  navigateToForgotPassword() {
    this.router.navigate(["/forgot-password"]);
  }

  getMessagesForField(fieldName: string): string[] {
    return this.messages.getValue().messagesFor(fieldName);
  }

  get TRUE(): boolean {
    return true;
  }
  get FALSE(): boolean {
    return false;
  }
}
